// What a person decides about a report's lot, saved the same way from every lab screen:
// put it on a lot (or on none), then confirm, so the rules neither flag it nor move it back.
// The report is read fresh first: the screen's copy may be stale, and saving it would undo a
// signature or final flag set meanwhile.
export async function decideLot($axios, reportId, inventoryId) {
  const fresh = (await $axios.get(`/inventory-lab-result/${reportId}`)).data;
  const target = inventoryId == null ? null : inventoryId;
  if ((fresh.inventoryId == null ? null : fresh.inventoryId) !== target) {
    await $axios.put(`/inventory-lab-result/${reportId}`, { ...fresh, inventoryId: target });
  }
  await $axios.post(`/inventory-lab-result/${reportId}/confirm-lot`);
}

// A person looked and the report stays where it is.
export function keepLot($axios, reportId) {
  return $axios.post(`/inventory-lab-result/${reportId}/confirm-lot`);
}

// The axios interceptor already shows network errors, 401/403s and 500s.
export function alreadyReported(error) {
  return !!((error && error.isAxiosError) || [401, 403, 500].includes(error && error.status));
}
